/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForOnpremMetricDataParser extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForOnpremMetricDataParser");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForOnpremMetricDataParser.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForOnpremMetricDataParser>): BackgroundJobPayloadForOnpremMetricDataParser {
        let obj = Object.assign(new BackgroundJobPayloadForOnpremMetricDataParser(), model);
        BackgroundJobPayloadForOnpremMetricDataParser.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForOnpremMetricDataParser>): BackgroundJobPayloadForOnpremMetricDataParser {
        if (!model) return null;
        return BackgroundJobPayloadForOnpremMetricDataParser.newInstance(<BackgroundJobPayloadForOnpremMetricDataParser> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForOnpremMetricDataParser) {
        if (!obj) return;

        models.BackgroundJobPayloadForOnpremMetricDataParser.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForOnpremMetricDataParser): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForOnpremMetricDataParser.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service account ID
     */
    service_account_id: string;

    /**
     * Unique resource identifier
     */
    resource_id: string;

    /**
     * Metric being reported
     */
    metric_name: string;

    /**
     * Complete raw SQS message in String
     */
    data: string;

}
